export default __webpack_public_path__ + "static/media/age.49ce74bb.svg";